import React from 'react';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Container from '@material-ui/core/Container';
import { Divider } from '@material-ui/core';
import { useSigninCheck } from 'reactfire';
import clsx from 'clsx';
import publicHeaderStyles from './styles';
import PublicFooter from '../../shared/components/PublicFooter';
import SearchPublicHeader from '../../shared/components/SearchPublicHeader';
import EmailVerificationBanner from '../../shared/components/EmailVerificationBanner';
import { useBackendUserState } from '../../contexts/UserContext';

const LayoutHeaderFooter = ({ children }) => {
  const classes = publicHeaderStyles();
  const { data: signInCheckResult } = useSigninCheck();
  const { state: { user: backendUser } = {} } = useBackendUserState();
  const emailVerified = backendUser?.emailVerified;
  const isUserAuthenticated = signInCheckResult.signedIn;

  const showEmailBanner = isUserAuthenticated && backendUser?.wizardState?.isWizardCompleted && emailVerified === false;

  return (
    <Box className={clsx(classes.root, {
      [classes.withEmailVerificationBanner]: showEmailBanner,
    })}
    >
      <SearchPublicHeader maxWidth="lg" />
      {showEmailBanner && <EmailVerificationBanner maxWidth="lg" />}
      <Container style={{ minHeight: 'calc(100vh - 157px)' }}>
        <Box
          className={classes.content}
          display="flex"
          flexDirection="column"
        >
          {children}
        </Box>
      </Container>
      <Divider />
      <PublicFooter />
    </Box>
  );
};

LayoutHeaderFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutHeaderFooter;
